import { DropdownHeader, Icon, Image } from "semantic-ui-react";

import type { OpenAPI } from "simplydo/interfaces";
import { AccessibleDropdown } from "simplydo/react/components/Accessibility/AccessibleDropdown";

import StyledDropdownItem from "components/lib/UI/StyledDropdownItem";

const BusinessProfileDropdownItem = ({
  businessProfile,
  selected,
}: {
  businessProfile: OpenAPI.Schemas["IdeaBusinessProfile"];
  selected?: boolean;
}) => {
  const { name, imageUrl, address = {}, _id } = businessProfile;
  const { country, city } = address;
  return (
    <StyledDropdownItem
      key={_id}
      text={name}
      image={
        imageUrl ?
          <Image
            src={imageUrl}
            style={{
              borderRadius: 2,
              overflow: "hidden",
              height: 28,
              width: 28,
              objectFit: "contain",
            }}
          />
        : <Icon name="building" size="large" />
      }
      description={
        city || country ?
          `${city || ""}${city && country ? ", " : ""}${country}`
        : null
      }
      selected={selected}
    />
  );
};

type IProfileSelector = {
  selectedBusinessProfile: OpenAPI.Schemas["IdeaBusinessProfile"];
  isLoading: boolean;
  existingProfiles: OpenAPI.Schemas["IdeaBusinessProfile"][];
  joinableProfiles?: OpenAPI.Schemas["IdeaBusinessProfile"][];
  joinProfile?: (profileId: any) => void;
  selectBusinessProfile: (
    ideaBusinessProfile: OpenAPI.Schemas["IdeaBusinessProfile"],
  ) => void;
  deselectBusinessProfile: () => void;
};

const BusinessProfileSelector = ({
  selectedBusinessProfile,
  isLoading,
  existingProfiles,
  joinableProfiles,
  joinProfile,
  selectBusinessProfile,
  deselectBusinessProfile,
}: IProfileSelector) => {
  return (
    <AccessibleDropdown
      selection
      fluid
      clearable
      placeholder="Select an organisation profile.."
      loading={isLoading}
      // @ts-ignore
      text={
        selectedBusinessProfile ?
          <BusinessProfileDropdownItem
            businessProfile={selectedBusinessProfile}
          />
        : null
      }
      value={selectedBusinessProfile?._id}
      onChange={(_e, { value }) => {
        if (!value) {
          deselectBusinessProfile();
        }
      }}
      options={[
        joinableProfiles?.length > 0 ?
          {
            value: "joinable-header",
            className: "header",
            content: <DropdownHeader content="Organisations you can join" />,
            disabled: true,
          }
        : null,
        ...joinableProfiles.map((joinableProfile) => ({
          key: joinableProfile._id,
          value: joinableProfile._id,
          content: (
            <BusinessProfileDropdownItem businessProfile={joinableProfile} />
          ),
          onClick: (_e, { value }) => {
            if (!value) {
              deselectBusinessProfile();
            } else {
              joinProfile?.(value);
              selectBusinessProfile(joinableProfile);
            }
          },
        })),
        joinableProfiles?.length > 0 ?
          {
            value: "existing-header",
            className: "header",
            content: <DropdownHeader content="Your organisations" />,
            disabled: true,
          }
        : null,
        ...existingProfiles.map((existingProfile) => ({
          key: existingProfile._id,
          value: existingProfile._id,
          content: (
            <BusinessProfileDropdownItem businessProfile={existingProfile} />
          ),
          onClick: (_e, { value }) => {
            if (!value) {
              deselectBusinessProfile();
            } else {
              selectBusinessProfile(existingProfile);
            }
          },
        })),
      ]}
    />
  );
};

export default BusinessProfileSelector;
